import { css } from '@wrisk/styled-system'
import React, { FunctionComponent } from 'react'
import styled from 'styled-components'

type RadioProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>

const RadioComponent: FunctionComponent<RadioProps> = (props) => {
  return (
    <div className={props.className}>
      <input {...props} type='radio' autoComplete={props.autoComplete || 'off'} />
      <span className='fake-radio' />
    </div>
  )
}

export const Radio = styled(RadioComponent)(
  css({
    width: '1.5rem',
    height: '1.5rem',
    minWidth: '1.5rem',
    minHeight: '1.5rem',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '1.5rem',
    input: {
      '&:hover': {
        cursor: 'pointer',
      },
    },
    "[type='radio']:checked, [type='radio']:not(:checked)": {
      position: 'absolute',
      opacity: '0',
    },
    'input + .fake-radio': {
      width: '1.5rem',
      height: '1.5rem',
      minWidth: '1.5rem',
      minHeight: '1.5rem',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '1.5rem',
      display: 'inline-block',
      borderRadius: '50%',
      outlineOffset: '2px',
    },
    'input:focus-visible + .fake-radio': {
      outlineWidth: '2px',
      outlineColor: 'focus',
      outlineStyle: 'solid',
    },
  }),
  ({ theme }) => ({
    'input:not(:checked) + .fake-radio': {
      backgroundImage: `url(${theme.icons.radioButtonOff.url})`,
    },
    'input:checked + .fake-radio': {
      backgroundImage: `url(${theme.icons.radioButtonOn.url})`,
    },
  }),
)
